/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import { View, TouchableOpacity, Dimensions } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Image from '@components/global/Image';
import { isNative } from '@global/screens';

const BackButton = (props) => {
  const goBack = async () => {
    const lastRouteStorage = await AsyncStorage.getItem('B2B-LAST-ROUTE');
    if (props.isHardBack && props.onPress) {
      props.onPress();
      return false;
    }

    if (lastRouteStorage && !props.notUseLastRoute) {
      const lastRoute = JSON.parse(lastRouteStorage);
      if (lastRoute?.key && lastRoute?.name != global.pageFrom) {
        if (lastRoute?.navigator) {
          props.navigation.navigate(lastRoute.navigator, {
            screen: lastRoute?.name,
            params: lastRoute?.params,
          });
        } else {
          props.navigation.navigate({
            name: lastRoute?.name,
            screen: lastRoute?.name,
            params: lastRoute?.params,
          });
        }
        return;
      }
    }

    if (props.onPress) {
      props.onPress();
      return false;
    }
    try {
      if (props.customBack && props.customBack.screen) {
        if (props.isJump) {
          props.navigation.navigate(
            props.customBack.screen,
            props.customBack.params ? props.customBack.params : {},
          );
        } else {
          props.navigation.replace(
            props.customBack.screen,
            props.customBack.params ? props.customBack.params : {},
          );
        }
      } else if (
        props.route &&
        props.route.params &&
        props.route.params.previous
      ) {
        props.navigation.navigate(props.route.params.previous);
      } else {
        props.navigation.pop();
      }
    } catch (error) {
      props.navigation.goBack();
    }
  };

  const BackItem = React.useMemo(() => {
    return isNative || Dimensions.get('window').width < 991 ? (
      <View style={{ flexDirection: 'row' }}>
        <TouchableOpacity
          style={{ paddingHorizontal: 15 }}
          onPress={() => goBack()}>
          <Image
            width={20}
            height={20}
            style={{ width: 20, height: 20 }}
            svg={true}
            source={require('@assets/img/icons/arrow-left-white.svg')}
          />
        </TouchableOpacity>
      </View>
    ) : (
      false
    );
  }, [isNative, Dimensions, goBack]);

  return BackItem;
};

export default React.memo(BackButton, (prev, next) => prev == next);
